import { call, put, takeLatest } from "redux-saga/effects";
import { getQuotationRequest, quotationRequestSuccess, quotationRequestFailure } from "../../slice/travel-insurance/insuranceQuotationSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchQuotationData = async quotationReq => {
  const FETCH_QUOTATION_API_URL = config.DAPI_INSURANCE_QUOTATION_API;
  const data = {
    mode: "no-cors",
    headers: {
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${FETCH_QUOTATION_API_URL}`, quotationReq, data);
  return response;
};
function* getInsuranceQuotationData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchQuotationData, payload);
    yield put(quotationRequestSuccess(response.data));
  } catch (error) {
    yield put(quotationRequestFailure(error));
  }
}
export function* watchInsuranceQuotation() {
  yield takeLatest(getQuotationRequest.type, getInsuranceQuotationData);
}